import { Component, Input } from '@angular/core';

interface WizardStep {
  step: number;
  label: string;
}

@Component({
  selector: 'app-color-tag-stepper',
  templateUrl: './color-tag-stepper.component.html',
  styleUrls: ['./color-tag-stepper.component.sass'],
})
export class ColorTagStepperComponent {
  @Input() currentStep: number;

  readonly steps: WizardStep[] = [
    { step: 1, label: 'Preview items' },
    { step: 2, label: 'AI analysis' },
    { step: 3, label: 'Review & edit' },
    { step: 4, label: 'Approve all' },
  ];
}
